import { render } from "./PanelistSurveyDashboardPage.vue?vue&type=template&id=f8853ec0&ts=true"
import script from "./PanelistSurveyDashboardPage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__